import React from 'react';
import { ThemeProvider } from 'investira.react.components';
import { useEntidadeAvaliacaoContext } from '../contexts/EntidadeAvaliacaoContext';
import { useDynamicEntidadeTheme } from '../themes/runtime';

const EntidadeThemeProvider = props => {
  const { state } = useEntidadeAvaliacaoContext();
  const theme = useDynamicEntidadeTheme(state.avaliacao?.entidade_theme || null);

  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};

export default EntidadeThemeProvider;
